// Assets
import { ReactComponent as InTransit } from '../asset/in_transit.svg';
import { ReactComponent as Info } from '../asset/info.svg';
import { ReactComponent as Delivered } from '../asset/check.svg';
import { ReactComponent as Return } from '../asset/return.svg';
import { ReactComponent as AvailableForPickup } from '../asset/available_for_pickup.svg';
import { ReactComponent as InTransitBlank } from '../asset/in_transit-blank.svg';
import { ReactComponent as InfoBlank } from '../asset/info-blank.svg';
import { ReactComponent as DeliveredBlank } from '../asset/check-blank.svg';
import { ReactComponent as ReturnBlank } from '../asset/return-blank.svg';
import { ReactComponent as AvailableForPickupBlank } from '../asset/available_for_pickup-blank.svg';
import { ReactComponent as Error } from '../asset/error.svg';
import { ReactComponent as ErrorBlank } from '../asset/error-blank.svg';
import { ReactComponent as Failure } from '../asset/failure.svg';
import { ReactComponent as FailureBlank } from '../asset/failure-blank.svg';
import { ReactComponent as Unknown } from '../asset/unknown.svg';
import { ReactComponent as UnknownBlank } from '../asset/unknown-blank.svg';
import { ReactComponent as Cancelled } from '../asset/cancelled.svg';
import { ReactComponent as CancelledBlank } from '../asset/cancelled-blank.svg';

export const icons = {
	pre_transit: <Info />,
	in_transit: <InTransit />,
	delivered: <Delivered />,
	out_for_delivery: <InTransit />,
	return: <Return />,
	return_to_sender: <Return />,
	available_for_pickup: <AvailableForPickup />,
	pre_transit_blank: <InfoBlank />,
	in_transit_blank: <InTransitBlank />,
	delivered_blank: <DeliveredBlank />,
	out_for_delivery_blank: <InTransitBlank />,
	return_blank: <ReturnBlank />,
	return_to_sender_blank: <ReturnBlank />,
	available_for_pickup_blank: <AvailableForPickupBlank />,
	error: <Error />,
	error_blank: <ErrorBlank />,
	failure: <Failure />,
	failure_blank: <FailureBlank />,
	unknown: <Unknown />,
	unknown_blank: <UnknownBlank />,
	cancelled: <Cancelled />,
	cancelled_blank: <CancelledBlank />
};

export const colors = {
	pre_transit: '#f2c94c',
	in_transit: '#6fb24b',
	delivered: '#6fb24b',
	out_for_delivery: '#6fb24b',
	return: '#eb5757',
	return_to_sender: '#eb5757',
	available_for_pickup: '#6fb24b',
	error: '#eb5757',
	failure: '#eb5757',
	unknown: '#6fb24b',
	cancelled: '#eb5757'
};

export const status = {
	pre_transit: 'pre_transit',
	in_transit: 'in_transit',
	delivered: 'delivered',
	out_for_delivery: 'out_for_delivery',
	return: 'return',
	return_to_sender: 'return_to_sender',
	available_for_pickup: 'available_for_pickup',
	error: 'error',
	failure: 'failure',
	unknown: 'unknown',
	cancelled: 'cancelled'
};
